import { FaExclamationTriangle } from 'react-icons/fa';
import { handleError } from '../apis';

export default function ShowError({
  isError,
  error,
}: {
  isError: boolean;
  error: any;
}) {
  if (!isError) return null;
  return (
    <p className='text-center p-4 text-rose-600 dark:text-rose-400'>
      <FaExclamationTriangle className='inline-block align-middle me-2' />{' '}
      {handleError(error) ?? 'An unknown error occurred.'}
    </p>
  );
}
